export function uuid(): string {
  return crypto.randomUUID();
}
